module.exports = __webpack_public_path__ + "static/media/lasouris.92bafd0e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/lasouris.webp
// module id = 407
// module chunks = 0